var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$hasConstruction('IEBDC:SY:ZXJF:SFZJ'))?_c('iframe',{staticClass:"iframe-style",attrs:{"src":_vm.returnTrustSrc,"frameborder":"0"}}):_c('no-data',{attrs:{"data":_vm.dataNo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }